import CircularProgress from '@mui/material/CircularProgress';
import TextField, { TextFieldProps } from '@mui/material/TextField';
import { InputLabelProps } from '@mui/material/InputLabel';
import Autocomplete, { AutocompleteProps } from '@mui/material/Autocomplete';

export interface IProps {
    error?: boolean;
    helperText?: string;
    name: string;
    InputProps?: TextFieldProps;
    InputLabelProps?: InputLabelProps;
    loading?: boolean;
    endAdornment?: React.ReactNode;
}

export function AutocompleteField<
    Value,
    Multiple extends boolean | undefined = false,
    DisableClearable extends boolean | undefined = false,
    FreeSolo extends boolean | undefined = false,
>({
    error,
    helperText,
    InputProps,
    InputLabelProps,
    disabled,
    loading,
    endAdornment,
    ...other
}: Omit<
    AutocompleteProps<Value, Multiple, DisableClearable, FreeSolo>,
    'renderInput'
> &
    IProps) {
    return (
        <Autocomplete
            {...other}
            disabled={disabled}
            renderInput={({
                InputLabelProps: InputLabelPropsAc,
                ...params
            }) => (
                <TextField
                    error={error}
                    helperText={helperText}
                    margin="normal"
                    variant="outlined"
                    {...InputProps}
                    {...params}
                    slotProps={{
                        input: {
                            ...params.InputProps,
                            endAdornment: (
                                <>
                                    {loading && (
                                        <CircularProgress
                                            color="inherit"
                                            size={20}
                                            sx={{ mr: 1 }}
                                        />
                                    )}
                                    {!loading && endAdornment}
                                    {params.InputProps.endAdornment}
                                </>
                            ),
                        },

                        inputLabel: {
                            ...InputLabelPropsAc,
                            ...InputLabelProps,
                        },
                    }}
                />
            )}
        />
    );
}
